import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

interface Game {
  id: number;
  name: string;
  provider: string;
  thumb: string;
}

const FEATURED_GAMES: Game[] = [
  {
    id: 35001,
    name: "Sugar Rush",
    provider: "Pragmatic Play",
    thumb: "https://assets.slotslaunch.com/35001/sugar-rush.jpg",
  },
  {
    id: 5706,
    name: "Sweet Bonanza",
    provider: "Pragmatic Play",
    thumb: "https://assets.slotslaunch.com/5706/sweet-bonanza.jpg",
  },
  {
    id: 15216,
    name: "Forge of Olympus",
    provider: "Pragmatic Play",
    thumb: "https://assets.slotslaunch.com/15216/forge-of-olympus.jpg",
  },
  {
    id: 3802,
    name: "Dragon's Fire",
    provider: "Red Tiger",
    thumb: "https://assets.slotslaunch.com/3802/dragons-fire.jpg",
  },
];

export function GameShowcase() {
  const [, navigate] = useLocation();

  return (
    <section id="automaty" className="py-16 bg-white" data-testid="section-games">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-gray-900 mb-2">
            Ponořte se do naší kolekce automatů a vyberte si online sloty podle svého vkusu
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
          {FEATURED_GAMES.map((game) => (
            <div
              key={game.id}
              className="rounded-xl border border-gray-100 bg-white hover-elevate cursor-pointer group overflow-hidden"
              data-testid={`game-card-${game.id}`}
              onClick={() => navigate("/automaty")}
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={game.thumb}
                  alt={game.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  width="300"
                  height="160"
                />
              </div>
              <div className="p-3">
                <div className="font-bold text-gray-900 text-sm leading-snug mb-0.5 truncate">{game.name}</div>
                <div className="text-gray-400 text-xs mb-2">{game.provider}</div>
                <Button
                  size="sm"
                  className="hraj-btn w-full font-bold text-xs gap-1"
                  style={{ background: "#003da5" }}
                  data-testid={`button-game-hraj-${game.id}`}
                >
                  Hraj
                  <ChevronRight className="w-3 h-3" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a href="/automaty">
            <Button variant="outline" className="hraj-btn-light font-semibold gap-2" data-testid="button-zobrazit-vice">
              Zobrazit více automatů
              <ChevronRight className="hraj-arrow w-4 h-4" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
